import { Menu, Text } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { projectsMenuEvents } from 'app/modules/wallforming/components/projects-manager/types/projectsMenuEvents';
import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SaveProjectAs = () => {
    const { t } = useTranslation();
    const hasActiveProject = usePlacementStore((state) => state.activeProject !== null);

    return (
        <Menu.Item
            disabled={hasActiveProject}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="save_as" />
            }
            rightSection={
                <Text className="action-menu-entry-decoration-text text-right min-w-14 text-[13px]">
                    {ShortcutAction.SaveProject}
                </Text>
            }
            onClick={() => window.dispatchEvent(new Event(projectsMenuEvents.openSave))}
        >
            {t('labelSaveProjectAs')}
        </Menu.Item>
    );
};
